export const OPEN = 'menu/OPEN';
export const CLOSE = 'menu/CLOSE';
export const CLOSE_CATEGORY = 'menu/CLOSE_CATEGORY';
export const SELECT_CATEGORY = 'menu/SELECT_CATEGORY';
export const CHANGE_SEARCH_TERM = 'menu/CHANGE_SEARCH_TERM';
export const CLEAR_SEARCH_TERM = 'menu/CLEAR_SEARCH_TERM';
export const SET_MENU_SOURCE = 'menu/SET_MENU_SOURCE';
